import { Observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { DashboardStore } from "../../stores/Layout/DashboardStore";
import AcxEmptyState from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";

interface OwnProps {
    parentHeightPx: number;
    dashboardStore?: DashboardStore;
}

type Props = OwnProps;

const EmptyDashboard: FunctionComponent<Props> = (props) => {
    return (
        <Observer>
            {() => (
                <>
                    {props.parentHeightPx > 0 && (
                        <AcxEmptyState
                            size="large"
                            showButton
                            height={props.parentHeightPx - 70}
                            onButtonClick={props.dashboardStore?.editDashboard}
                            variant="new"
                        />
                    )}
                </>
            )}
        </Observer>
    );
};

export default EmptyDashboard;
